import styles from './Countdown.module.scss';

export function Countdown({ countDownTimer }) {
	return <div className={styles.countdown}>{countDownTimer}</div>;
}

export default Countdown;